import { getRightList } from '@/infrastructure/api-functions';
import { ListBaseService } from '@eureka/shared/solution-card';
import { SOLUTION_TYPE, type ISolutionListResponse } from '@eureka/shared/solution-card/src/types';

export class CompanyListService extends ListBaseService {
    protected fetchData(
        data: {
            page: number, limit: number, data?: Record<string, unknown>
        }
    ): Promise<ISolutionListResponse> {
        return getRightList(data).then(res => {
            res.records = res.records.map((item) => {
                if (item.SOLUTION_TYPE === SOLUTION_TYPE.PAPER) {
                    item.ORG_INFO = item.ORG_INFO?.map(
                        (org) => {
                            return {
                                display_name: org.normalized_display_name,
                                id: org.normalized_id,
                                logo: org.normalized_logo,
                            };
                        }
                    )
                }
                return item
            });
            return res
        })
    }
}
